import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { AchmeaBanner } from "./AchmeaBanner";

type Props = ThemeSlotPropsMap["pageHeading"];

const IMAGE_MAP: Record<string, string> = {
  advice:
    "https://www.achmeamortgages.nl/-/jssmedia/achmeamortgages/afbeeldingen/over-ons/medres_dsc08554.jpeg?mw=1280",
  documentsOutgoing:
    "https://www.achmeaglobalneth.nl/-/jssmedia/achmeaglobalneth/afbeeldingen/maatwerkdiensten/maatwerkdiensten-hero.jpg?mw=1280",
  documentsIncoming:
    "https://www.achmeaglobalneth.nl/-/jssmedia/achmeaglobalneth/afbeeldingen/maatwerkdiensten/maatwerkdiensten-hero.jpg?mw=1280",
  interestRates:
    "https://www.achmeaglobalneth.nl/-/jssmedia/achmeaglobalneth/afbeeldingen/claimmanagement/claimmanagement-onze-expertise-groot.jpg?mw=1280",
  maximumMortgage:
    "https://www.achmeamortgages.nl/-/media/achmeamortgages/afbeeldingen/beleggen/pvf/highres_syntrus-achmea-straat.jpg?h=851&iar=0&w=1280&cx=0.5&cy=0.5&v=1&d=20260331T122004Z&hash=7B13D248E8ECEAAE2FF16883783503D5",
  orientation:
    "https://www.achmeamortgages.nl/-/jssmedia/achmeamortgages/afbeeldingen/beleggen/pvf/over-het-fonds.png?mw=2000",
};

export const AchmeaPageHeading: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();

  return (
    <AchmeaBanner
      title={t(`${scope}Heading.title`)}
      description={t(`${scope}Heading.description`)}
      imageSrc={IMAGE_MAP[scope] ?? ""}
    />
  );
};
